export default (input) => {
  return input.toUpperCase()
}



// WEBPACK FOOTER //
// ./src/filter/uppercase/UppercaseFilter.js